import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminNav from './AdminNav';
import './AdminLayout.css';

const AdminLayout = () => {
  const userInfo = useSelector((state) => state.user.userInfo);
  const adminName = `${userInfo?.userDocument?.firstName || "System"} ${userInfo?.userDocument?.lastName || "Admin"}`.trim();
  const adminEmail = userInfo?.userDocument?.email || "admin@gmail.com";

  return (
    <div className="admin-shell">
      <aside className="admin-sidebar">
        <div className="admin-brand">
          <span>HPWP</span>
          <small>Admin Console</small>
        </div>
        <AdminNav />
      </aside>
      <main className="admin-main">
        <div className="admin-topbar">
          <div className="admin-profile">
            <div className="admin-avatar">
              <img src="/assets/images/icon/administration.svg" alt="Admin avatar" />
            </div>
            <div className="admin-profile-text">
              <span>Welcome back,</span>
              <h4>{adminName}</h4>
              <p>{adminEmail}</p>
            </div>
          </div>
        </div>
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
